import { Day } from "../../offering/day_utils";

export interface CreatePhysicalSpaceInput extends PhysicalSpaceInput {
  locationID: string;
  spaceType: "private_office";
  capacity: number;
  withWindow: boolean;
}

export interface useFMDayOfficePhysicalSpacesParams {
  startDate?: string;
  endDate?: string;
}

export function fromCreatePhysicalSpaceInput(input: CreatePhysicalSpaceInput) {
  return {
    location_id: input.locationID,
    space_type: input.spaceType,
    capacity: input.capacity,
    with_window: input.withWindow,
    ...fromPhysicalSpaceInput(input),
  };
}

export interface FMPhysicalSpace extends BasePhysicalSpace {
  capacity: string;
  withWindow: string;
}

export function toFMPhysicalSpace(data: any): FMPhysicalSpace {
  return {
    capacity:
      data.space.space_layouts.length > 0
        ? data.space.space_layouts[0].capacity
        : 0,
    withWindow: data.with_window,
    ...toBasePhysicalSpace(data),
  };
}

export interface PhysicalSpaceInput {
  name: string;
  floor: string;
  startDate: Day;
  endDate: Day;
}

export function fromPhysicalSpaceInput(input: PhysicalSpaceInput) {
  return {
    name: input.name,
    floor: input.floor,
    start_date: input.startDate || undefined,
    end_date: input.endDate || undefined,
  };
}

export interface BasePhysicalSpace {
  id: string;
  name: string;
  spaceID: string;
  floor: string;
  startDate: string;
  endDate: string;
}

export function toBasePhysicalSpace(data: any): BasePhysicalSpace {
  return {
    id: data.id,
    spaceID: data.space_id,
    name: data.name,
    floor: data.floor,
    startDate: data.start_date,
    endDate: data.end_date,
  };
}
